import ImageGallery from "react-image-gallery"
import { Box } from "@mui/material"

import changeImageSize from "../../../utils/changeImageSize"

interface Images {
	images: string[]
}

const getProductImages = (images: string[]) =>
	images.map((img) => ({
		original: `${changeImageSize(img, "large")}`,
		thumbnail: `${changeImageSize(img, "medium")}`,
	}))

export const SliderV3 = ({ images }: Images) => {
	const items = getProductImages(images)

	return (
		<Box mt={2}>
			<ImageGallery
				items={items}
				useBrowserFullscreen={false}
				showPlayButton={false}
				showBullets={false}
			/>
		</Box>
	)
}

export default SliderV3
